// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes, matchRoutes } from 'react-router-config';
import { I18nextProvider } from 'react-i18next';
import etask from 'zetask';
import www_util from 'hola_pub_util';
import hopt from 'hola_opt';
import { get_aliased_pathname } from '../../hola/pub/lib/use_pathname';
import be from './be.js';
import { dom_hydrate, dom_render } from './react_util.js';
import { get_app_routes } from './routes.js';
import { App } from './app.js';
import i18n from './i18n.js';
import fetch_util from '/util/fetch.js';
import { Data_context } from './data_ctx.tsx';
import './css/homepage2.less';

// XXX dmitriiz: Copied from luminati zon:
// This is a workaround to avoid crash when
// customer uses some translation extension. Once the google translate
// issue will be fixed, the workaround shoud be removed:
// https://bugs.chromium.org/p/chromium/issues/detail?id=872770
// see details of the solution here:
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
var error_remove_child = 'Cannot remove a child from a different parent';
var error_insert_before = 'Cannot insert before a reference node from a ' + 'different parent';
var patch_DOM_for_translate = () => {
  var original_remove_child = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (!child.skip_dom_translate_patch && child.parentNode !== this) {
      console.error(error_remove_child, child, this);
      return child;
    }
    return original_remove_child.apply(this, arguments);
  };
  var original_insert_before = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (new_node, reference_node) {
    if (reference_node && reference_node.parentNode !== this) {
      console.error(error_insert_before, reference_node, this);
      return new_node;
    }
    return original_insert_before.apply(this, arguments);
  };
};
export var init = opt => etask(function* () {
  var _hopt$www_hola;
  fetch_util.init();
  patch_DOM_for_translate();
  yield www_util.init(opt);
  /* XXX dmitriiz: think how to optimise transferring HTML
  if (opt.data_for_render)
  {
      const ssr_el = document
          .querySelector(`[data_id_ssr="${opt.data_for_render}"]`);
      if (ssr_el)
          opt.data_for_render = ssr_el.innerHTML;
  }*/
  var i18n_ = i18n(opt);
  opt.i18n_instance = i18n_;
  var routes = get_app_routes(App, _objectSpread(_objectSpread({}, hopt), {}, {
    host: opt.host,
    dynamic_routes: opt.dynamic_routes
  }), Data_context);
  be.init({
    block_unblocking_rate: location.pathname.indexOf('/vpn_config') == 0 || location.host.indexOf('haffnetwork') == 0,
    get_user: www_util.get_user,
    skip_bext: true
  });
  be.init_perr();
  be.refresh_membership({
    user: opt.user,
    skip_bext: true,
    get_user: www_util.get_user
  });
  www_util.save_orig_ref();
  www_util.invalidate_no_log(opt.is_active);
  var pathname_current = location.pathname;
  var pathname = get_aliased_pathname(pathname_current);
  var matched = matchRoutes(routes, pathname) || [];
  // preload async components
  yield etask.all(matched.map(m => {
    var component = m.route.component;
    if (component && component.load) return component.load();
  }));
  yield i18n_._init_process;
  var component = /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18n_,
    initialLanguage: opt.lang,
    initialI18nStore: opt.i18n_store
  }, /*#__PURE__*/React.createElement(BrowserRouter, null, renderRoutes(routes, opt)));
  var root = document.getElementById('react-root');
  var new_rd_api = hopt === null || hopt === void 0 ? void 0 : (_hopt$www_hola = hopt.www_hola) === null || _hopt$www_hola === void 0 ? void 0 : _hopt$www_hola.new_rd_api;
  if (opt.is_ssr) dom_hydrate(component, root, new_rd_api);else dom_render(component, root, new_rd_api);
});